import importer from 'common/importer'
const { oktaReq: req } = importer('APIs', null)
/**
 * Generates a one-time token (OTT) that can be used to reset a user's password
 * @param {String} id `REQUIRED`
 * @param {String} api_token `REQUIRED`
 * @param {Boolean} sendEmail defaults to `true`
 */
export const forgotPassword = (id, api_token, sendEmail = true) => {
  const config = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `SSWS ${api_token}`
    }
  }
  return req.post(`/users/me/${id}/credentials/forgot_password?sendEmail=${sendEmail}`, null, config)
}
